import { isRejectedWithValue } from '@reduxjs/toolkit';
import axios from 'axios';

export const extraHeaders = (headers, { getState }) => {
  const token = localStorage.getItem('jwt_access_token');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  headers.set('Accept-Language', getState().i18n?.language || 'uz');
  return headers;
};

export const rtkBaseQuery =
  (basePath = '') =>
  async (args, api, extraOptions) => {
    let url, method, data, params, responseType;
    if (typeof args === 'string') {
      url = args;
      method = 'GET';
      data = undefined;
      params = undefined;
      responseType = undefined;
    } else {
      url = args.url;
      method = args.method || 'get';
      data = args.body;
      params = args.params;
      responseType = args.responseType;
    }
    // Prepend basePath if not already present
    if (basePath && url && !url.startsWith(basePath)) {
      url = basePath.replace(/\/$/, '') + '/' + url.replace(/^\//, '');
    }
    try {
      const axiosConfig = {
        url,
        method,
        data,
        params,
      };
      if (responseType) {
        axiosConfig.responseType = responseType;
      }
      const result = await axios.request(axiosConfig);
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data,
        },
      };
    }
  };

export const rtkQueryErrorLogger = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = action.payload.status || null;
    const message = action.payload.data?.message || 'We got a rejected action!';
    if (status === 401) {
      const language = localStorage.getItem('language');
      const isDarkMode = localStorage.getItem('isDarkMode');
      localStorage.clear();
      localStorage.setItem('language', language);
      localStorage.setItem('isDarkMode', isDarkMode);
      window.location.href = '/';
      console.error('Unauthorized! Redirecting to login...');
    } else if (status > 300 && status < 600) {
      console.warn(message);
    }
  }
  return next(action);
};

export const urlWithSearchParams = (url, params) => {
  const searchParams = new URLSearchParams(params);
  return `${url}?${searchParams.toString()}`;
};
